import axios, { InternalAxiosRequestConfig } from "axios";

// export const BASE_URL = "http://192.168.29.218:2001/api/v1/admin";
// export const IMAGE_URL = "http://192.168.29.218:2001/api/v1/admin/"
// export const BASE_URL = "https://api.ilap.oceansoft.online/api/v1/admin";
// export const IMAGE_URL = "https://api.ilap.oceansoft.online/api/v1/admin/"
export const BASE_URL = "https://api.ilap.me/api/v1/admin";
export const IMAGE_URL = "https://api.ilap.me/api/v1/admin/"
// export const BASE_URL = process.env.ADMIN_APP_API_BASE_URL;
// export const IMAGE_URL = process.env.ADMIN_APP_IMAGE_URL;

export const apiClient = axios.create({
  baseURL: BASE_URL,
});
apiClient.interceptors.request.use(
  function (config) {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("adminToken")}`;
    config.headers["Content-Type"] = "application/json";

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  function (error) {
    Promise.reject(error);
  }
);

export default apiClient;
